module.exports = __webpack_public_path__ + "fa79e044d9098dedd420fdb9bf49d364.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Trilliant.png
// module id = 799
// module chunks = 0